import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

const ToggleSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${size(2)};
  width: 100%;
`

const ToggleTitle = styled.span`
  display: flex;
  align-items: center;

  font-size: ${fontSize('lg')};
  font-weight: 500;
`

const ToggleOptions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${size(1)};
  row-gap: ${size(1)};

  width: 100%;
  padding-top: ${size(2)};
  padding-bottom: ${size(2)};
`

const SliderSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${size(3)} ${size(2)} 0 ${size(2)};
`

const SliderTitle = styled.span`
  display: flex;
  align-items: center;

  font-size: ${fontSize('lg')};
  font-weight: 500;
`

export { ToggleSection, ToggleOptions, ToggleTitle, SliderSection, SliderTitle }
